import React, { useState, useEffect } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography, Button, Checkbox } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useStyles } from './SignDocumentsPreviwStyle';

const SignDocumentPreview = ({ applications, onAllDownload }) => {
  const classes = useStyles();
  const pending = false;

  const [downloadedDocs, setDownloadedDocs] = useState([]);
  const [checkedDocs, setCheckedDocs] = useState({}); // Track checkbox state for each document

  const collateralDocuments = applications.filter(app => app.documentType === 'Collateral Document');
  const insuranceAgreements = applications.filter(app => app.documentType === 'Insurance Agreement');
  const cardholderAgreements = applications.filter(app => app.documentType === 'Cardholder Agreement');

  const allDocuments = [...collateralDocuments, ...insuranceAgreements, ...cardholderAgreements];

  const handleCheckboxChange = (docId) => {
    if (!checkedDocs[docId]) {
      setCheckedDocs((prev) => ({
        ...prev,
        [docId]: true,
      }));
    }
  };

  const handleDownload = (docId) => {
    if (!downloadedDocs.includes(docId)) {
      setDownloadedDocs((prev) => [...prev, docId]);
    }
  };

  useEffect(() => {
    if (downloadedDocs.length === allDocuments.length && allDocuments.length > 0) {
      onAllDownload();
    }
  }, [downloadedDocs, allDocuments, onAllDownload]);

  const renderDocuments = (documents) =>
    documents.map((doc) => (
      <div
        key={doc.id}
        style={{
          background: "#F4EBFE",
          width: "100%",
        }}
      >
        <div style={{ width: "90%", margin: "40px auto", display: "flex", flexDirection: "column" }}>
        <Typography>
          I hereby confirm that I have read and reviewed the Forms and in consideration of the Bank accepting my Forms and
          considering my credit application, I consent to any and all matters requiring my consent or approval therein and 
          I attach my electronic signature hereto to evidence said approval.
          <br/>
          <br/>
          I agree that if at any time I provide or have provided the Bank with false or misleading information or withhold or 
          have withheld any information, the Bank will have the right to reject any application or terminate my credit facility.
          <br/>

        </Typography>
          <Button
            href={`${doc.documentFile}`}
            download={`${doc.documentType}.pdf`}
            style={{ background: 'none', margin: '0', padding: 0, border: "none" }}
            onClick={() => handleDownload(doc.id)}
          >
            {doc.documentType}.pdf
          </Button>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Checkbox
              checked={checkedDocs[doc.id] || false}
              onChange={() => handleCheckboxChange(doc.id)}
              disabled={!downloadedDocs.includes(doc.id) || checkedDocs[doc.id]}
            />
            <Typography style={{ marginBottom: 0 }}>Documents were read and understood</Typography>
          </div>
        </div>
      </div>
    ));

  return (
    <Stack spacing={{ xs: 4, md: 2 }} direction="column" mb={3} width="100%">
      {downloadedDocs.length === allDocuments.length && (
        <Typography variant="h6" style={{ color: 'green', textAlign: 'center', marginBottom: '1rem' }}>
          All documents have been downloaded!
        </Typography>
      )}

      <Accordion elevation={0} className={classes.Accordian}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2" className={classes.AccordianHeader}>
            Collateral Documents
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {pending ? (
            <Typography variant="body2">Loading...</Typography>
          ) : collateralDocuments.length > 0 ? (
            renderDocuments(collateralDocuments)
          ) : (
            <Typography variant="body2">No collateral documents found.</Typography>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Repeat for other document categories */}
      {/* Insurance Agreements */}
      <Accordion elevation={0} className={classes.Accordian}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2" className={classes.AccordianHeader}>
            Insurance Agreements
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {pending ? (
            <Typography variant="body2">Loading...</Typography>
          ) : insuranceAgreements.length > 0 ? (
            renderDocuments(insuranceAgreements)
          ) : (
            <Typography variant="body2">No insurance agreements found.</Typography>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Cardholder Agreements */}
      <Accordion elevation={0} className={classes.Accordian}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2" className={classes.AccordianHeader}>
            Cardholder Agreements
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {pending ? (
            <Typography variant="body2">Loading...</Typography>
          ) : cardholderAgreements.length > 0 ? (
            renderDocuments(cardholderAgreements)
          ) : (
            <Typography variant="body2">No cardholder agreements found.</Typography>
          )}
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

export default SignDocumentPreview;
